// helps to close the tags


export const closingColon = (readLines, index, operation, closingTag) => {
    // detect the closing colon and convert it to div
    let stack = [];
    let openingColon = /:/;
    let closingColon = /;/;
    // console.log(readLines);

    for (let i = index; i < readLines.length; i++) {
      let x = readLines[i];
      if (operation.isTrue(x)) {
        operation.hasOpened = true;
      }

      if (openingColon.test(x) && operation.hasOpened) {
        stack.push(":");
      } else if (closingColon.test(x)) {
        stack.pop();
      }
    //   console.log(stack);
      if (!stack.length) {
        // console.log(`closing for ${index + 1} is ${i + 1}`); // cliosing tags for specif
        readLines[i] = closingTag;
        operation.hasOpened = false;
        return;
      }
    }
  }
